import { RouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const legalRoutes: RouteConfig[] = [
	{
		path: `/legal/ira-fee-payment-program`,
		name: 'ira-paid-fees-terms-and-conditions',
		component: () =>
			import(
				/* webpackChunkName: "ira-paid-terms-and-conditions" */ '@views/ira/general/ira-paid-fees-terms-and-conditions.vue'
			)
	},
	{
		path: `/legal/invitation-program`,
		name: 'referral-terms-conditions',
		component: () =>
			import(/* webpackChunkName: "referral-terms-conditions" */ '@views/referral/referral-terms-conditions.vue')
	},
	{
		path: `/legal/disclosure`,
		name: 'disclosures',
		component: () => import(/* webpackChunkName: "disclosures" */ '@views/legal/disclosures.vue')
	},
	{
		path: `/legal/promo`,
		name: 'starter-promo-terms',
		component: () => import(/* webpackChunkName: "starter-promo-terms" */ '@views/legal/starter-promo.vue')
	},
	{
		path: `/oc`,
		name: 'offering-circulars',
		component: () => import(/* webpackChunkName: "offering-circulars" */ '@views/legal/offering-circulars.vue')
	},
	{
		path: `/oc/links`,
		name: 'offering-circulars-links',
		component: () =>
			import(/* webpackChunkName: "offering-circulars-links" */ '@views/legal/offering-circulars.vue')
	}
];

export default legalRoutes;
